import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { contactInfo } from '../mock';

export default function WhatsappFloat() {
  const { lang } = useLang();
  return (
    <a
      href={`https://wa.me/${contactInfo.whatsapp}?text=${encodeURIComponent('Namaste, I have a query regarding puja')}`}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-[#25D366] hover:bg-[#1ea955] text-white px-5 py-3 rounded-full shadow-xl font-semibold text-sm transition transform hover:scale-105"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline">{lang === 'en' ? 'Chat on Whatsapp' : 'व्हाट्सएप पर चैट'}</span>
    </a>
  );
}
